import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { messages } from "../../locales/messages";
import { formatDateInEasternTime } from "../../utils/dateUtil/formatDateInEasternTime";

type RetryCoordinatesConfirmDescriptionProps = {
  storeName?: string;
  validStartDate?: Date | string;
  validEndDate?: Date | string;
  imageCount?: number;
};

const formatDate = (value?: Date | string) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : formatDateInEasternTime(value);
};

export function RetryCoordinatesConfirmDescription({
  storeName,
  validStartDate,
  validEndDate,
  imageCount,
}: RetryCoordinatesConfirmDescriptionProps) {
  const { t } = useTranslation();

  const dateRange =
    validStartDate && validEndDate
      ? `${formatDate(validStartDate)} – ${formatDate(validEndDate)}`
      : "-";

  const imageCountLabel =
    imageCount != null ? String(imageCount) : "-";

  return (
    <Box component="div">
      <Typography variant="body2" sx={{ mb: 2 }}>
        {t(messages.Retry_Coordinates_Description())}
      </Typography>
      <Box
        component="ul"
        sx={{ m: 0, pl: 2.5, "& li": { mb: 0.5 } }}
      >
        <li>
          <strong>{t(messages.Merchant())}:</strong> {storeName?.trim() || "-"}
        </li>
        <li>
          <strong>{t(messages.Retry_Coordinates_Date_Range())}:</strong>{" "}
          {dateRange}
        </li>
        <li>
          <strong>{t(messages.Retry_Coordinates_Image_Count())}:</strong>{" "}
          {imageCountLabel}
        </li>
      </Box>
    </Box>
  );
}
